module.exports = {"title":"문의 등록","typeLabel":"유형","typeSelectPlaceholder":"유형을 선택하세요.","titleLabel":"제목","titlePlaceholder":"제목을 입력하세요.","contentPlaceholder":"내용을 입력하세요.","typeService":"서비스","typeEvent":"이벤트","typeUpdate":"업데이트","templateService":"디바이스: PC / 모바일 \n","templateEvent":"이벤트 내용: \n","templateUpdate":"업데이트 버전: \n","registeredAlert":"문의사항이 등록되었습니다.","registerFailedAlert":"글 등록에 실패했습니다.<br>다시 시도해주세요."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs103.json
// module id = XnA+
// module chunks = 2